import axios from 'axios';
import RestService from '../../../../../../helpers/RestService';
import { QUESTION_CHANGE_COMMENTS } from '../../../../../../modules/questions';

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';

export async function createComment(body) {
  // return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/comments/post', body);
      if(data.errcode == 200) {
        // dispatch({
        //   type : QUESTION_CHANGE_COMMENTS,
        //   payload : {
        //       questionId: body.question_id,
        //       comments: data.payload,
        //   }
        // });
        return data.payload;
      } else {
        return []
      }
    } catch (error) {
      return []
    }
  // }
}

export async function getComments(question_id) {
  // return async (dispatch) => {
    try {
      const {data} = await axios.get('/api/comments/get?question_id=' + question_id);
      if(data.errcode == 200) {
        // dispatch({
        //   type : QUESTION_CHANGE_COMMENTS,
        //   payload : {
        //       questionId: body.question_id,
        //       comments: data.payload,
        //   }
        // });
        return data.payload;
      } else {
        return []
      }
    } catch (error) {
      return []
    }
  // }
}
export async function deleteComment(body) {
  // return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/comments/delete', body);
      if(data.errcode == 200) {
       
        // dispatch({
        //   type : QUESTION_CHANGE_COMMENTS,
        //   payload : {
        //       questionId: body.question_id,
        //       comments: data.payload,
        //   }
        // });
      
        return data.payload;
      } else {
        return []
      }
    } catch (error) {
      return []
    }
  // }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmBody/QuestionForm/components/Comments/actions.js